export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9128.8ba117d4.jpg";